import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { actionCreators } from '../store/ClimaControl';
import { Col, Grid, Row, Alert, Button, FormGroup, FormControl, ControlLabel, HelpBlock } from 'react-bootstrap';

class ClimaControl extends React.Component {
    constructor(props) {
        super(props);
        //this.state = { mobile: "+3069", email: "", phrase: "" };
        this.state = {
            mobile: props.mobile, email: props.email, phrase: props.phrase,
            metricCO2: props.metricCO2,
            metricTemperature: props.metricTemperature,
            metricHumidity: props.metricHumidity,
            metricDustDensity: props.metricDustDensity,
        };
        console.log("constructor");
    }

    componentWillMount() {
        // This method runs when the component is first added to the page
        //const startDateIndex = parseInt(this.props.match.params.startDateIndex, 10) || 0;
        this.props.getAlertData().then();
    }

    updateEmail = email => {
        console.log(`updateEmail: ${email}`);
        this.setState({ email });
    };

    updateMobile = mobile => {
        //console.log(`updateMobile: ${mobile}`);
        this.setState({ mobile });
    };

    updatePhrase = phrase => {
        //console.log(`updatePhrase: ${phrase}`);
        this.setState({ phrase });
    };

    updateMetricCO2 = metricCO2 => {
        this.setState({ metricCO2 });
    }

    updateMetricDustDensity = metricDustDensity => {
        this.setState({ metricDustDensity });
    }

    updateMetricTemperature = metricTemperature => {
        this.setState({ metricTemperature });
    }

    updateMetricHumidity = metricHumidity => {
        this.setState({ metricHumidity });
    }

    handleSetAlertData = () => {
        console.log("handleSetAlertData");

        this.props.setAlertData(this.state.email, this.state.mobile, this.state.phrase, this.state.metricTemperature, this.state.metricHumidity, this.state.metricDustDensity, this.state.metricCO2).then((result) => {
            if (result.code == 0) {
                alert("Settings saved.");
                this.state.phrase = "";
                this.props.history.push('/');
            }
        });
        //this.props.setAlertData();
        //this.setState({ mobile: "+3069", phrase: "" });
    };

    render() {
        return (
            <div>
                <h1 className="fontcolor">Clima Control Station - Alert Configuration</h1>
                <Grid fluid>
                    <Row>
                        <Col sm={12}>
                            <p>Textboxes show a fragment of currrently defined settings. New settings are persisted for about 30 minutes, after this period the default values are used.</p>
                            <Alert bsStyle="warning">Emails may apear in Spam / Junk folder</Alert>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <FormGroup>
                                <ControlLabel>Email</ControlLabel>
                                <FormControl type="email"  name="email"
                                    onChange={e => this.updateEmail(e.target.value)}
                                    value={this.state.email || this.props.email} placeholder="email@domain.gr"
                                />
                                <HelpBlock>GMail email addresses seem to not work well with SendGrid (the selected mail service to send out email alerts)</HelpBlock>
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <ControlLabel>Mobile</ControlLabel>
                                <FormControl type="text"  name="mobile"
                                    onChange={e => this.updateMobile(e.target.value)}
                                    value={this.state.mobile || this.props.mobile} placeholder="+3069xxxxxxxx"
                                />
                                <HelpBlock>ClickSend allows 25 SMS messages per month in free plans.</HelpBlock>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <FormGroup>
                                <ControlLabel>Phrase</ControlLabel>
                                <FormControl type="password" name="phrase"
                                    onChange={e => this.updatePhrase(e.target.value)}
                                    value={this.state.phrase} placeholder="Pass phrase"
                                />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <h3>Alert Thresholds</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <FormGroup>
                                <ControlLabel>Temperature (* C)</ControlLabel>
                                <FormControl type="number" name="metricTemperature"
                                    onChange={e => this.updateMetricTemperature(e.target.value)}
                                    value={this.state.metricTemperature || this.props.metricTemperature} placeholder=""
                                />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <ControlLabel>Humidity (RH %)</ControlLabel>
                                <FormControl type="number" name="metricHumidity"
                                    onChange={e => this.updateMetricHumidity(e.target.value)}
                                    value={this.state.metricHumidity || this.props.metricHumidity} placeholder=""
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <FormGroup>
                                <ControlLabel>Dust Density (μgr/m3)</ControlLabel>
                                <FormControl type="number" name="metricDustDensity"
                                    onChange={e => this.updateMetricDustDensity(e.target.value)}
                                    value={this.state.metricDustDensity || this.props.metricDustDensity} placeholder=""
                                />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <ControlLabel>CO2 Concentration (ppm)</ControlLabel>
                                <FormControl type="number" name="metricCO2"
                                    onChange={e => this.updateMetricCO2(e.target.value)}
                                    value={this.state.metricCO2 || this.props.metricCO2} placeholder=""
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <FormGroup>
                                <Button bsStyle="primary" onClick={this.handleSetAlertData} disabled={this.props.isLoading || false}>
                                    {(!this.props.isLoading || 0 ? 'Submit Alert Settings' : '   Loading ...' )}
                                </Button>
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <Alert bsStyle={(this.props.result.code === 0 ? "info" : "danger")}>{this.props.result.message}</Alert>
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}

export default connect(
    state => state.climaControl,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(ClimaControl);
// export default ClimaControl;



// WEBPACK FOOTER //
// ./src/components/ClimaControl.js